import { Component, OnInit } from '@angular/core';
import { CoreService } from '../../../../../service/core.service';
import { ApiService } from '../../../../../service/api.service';
import * as XLSX from 'xlsx';
import { TranslateService,LangChangeEvent } from '@ngx-translate/core';
import { ExcelService } from '../../../../../service/excel.service';
import { CurrencyPipe } from '@angular/common';

@Component({
  selector: 'app-van-distributors-rep-two',
  templateUrl: './van-distributors-rep-two.component.html',
  styleUrls: ['./van-distributors-rep-two.component.css']
})
export class VanDistributorsRepTwoComponent implements OnInit {
  fileName = 'van_distributors_rep_2.xlsx';
  pageLoadingImg: boolean;
  saleData: any;
  repDate: any;
  VanList: any;
  filter_types: { id: string; name: any; }[];
  country_dec: number;
  branch_display_name: any;
  branch_display_code: any;
  branch_address: any;
  period_type: any;
  exportLoader: boolean;

  constructor(private apiService: ApiService, private coreService: CoreService,private translate: TranslateService,private excelService: ExcelService,private currencyPipe: CurrencyPipe) { }

  ngOnInit() {

    this.period_type='t';
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.langChange();
    });
    this.langChange();
    this.country_dec=this.coreService.setDecimalLength();
    this.branch_display_name = this.coreService.getUserData('branch_disp_name');
    this.branch_display_code = this.coreService.getUserData('branch_code');
    this.branch_address = this.coreService.getUserData('branch_address');
  }

  selectVan(van) {
    if (van) {
      this.pageLoadingImg = true;
      const searchval = new FormData();
      searchval.append('van_ledger_id', van.van_cash_ledger_id);
      searchval.append('van_id', van.van_id);
      searchval.append('period_type', 't');
      this.apiService.vanDistributorsRep2(searchval).subscribe((res) => {
        this.saleData = res.data;
        this.pageLoadingImg = false;
        this.repDate = res.data.Date

        // this.VanList.push({ "van_id": 'All', 'van_name': 'All' });
      });

    } else {
      this.saleData = [];

    }
  }

  searchVans(search: string) {
    const searchval = new FormData();
    searchval.append('van_name', search);
    this.apiService.searchVans(searchval).subscribe((res) => {
      this.VanList = res['data'];
      // this.VanList.push({ "van_id": 'All', 'van_name': 'All' });
    });

  }

  langChange(){
    this.translate.get(['Common.today', 'Common.last_day','Common.last_week', 'Common.last_maonth','Common.last_yr', 'Common.cust_date','Common.all']).subscribe((res: string) => {    
     
      
      this.filter_types = [
        
    { id: 't', name: res['Common.today'] },
    { id: 'ld', name: res['Common.last_day'] },
    { id: 'lw', name: res['Common.last_week'] },
    { id: 'lm', name: res['Common.last_maonth'] },
    { id: 'ly', name: res['Common.last_yr'] },
    { id: 'c', name: res['Common.cust_date'] },
    { id: 'all', name: res['Common.all'] }
        
      ];
    });
  }

  filterSearch(formdata: { value: any; }, van) {
    if (van) {
      this.pageLoadingImg = true;
      const searchval = new FormData();
      formdata.value.van_ledger_id = van.van_cash_ledger_id;
      formdata.value.van_id = van.van_id;
      if (formdata.value.period_type === 'c') {
  
        formdata.value.date1 = (formdata.value.date1) ? this.apiService.formatDate(formdata.value.date1) : formdata.value.date1;
        formdata.value.date2 = (formdata.value.date2) ? this.apiService.formatDate(formdata.value.date2) : formdata.value.date2;
        
      }
    
      this.apiService.vanDistributorsRep2(formdata.value).subscribe((res) => {
        this.saleData = res.data;
        this.pageLoadingImg = false;
        this.repDate = res.data.Date
      });

    } else {
      this.saleData = [];

    }
  }

  exportexcel(): void {
    this.exportLoader = true;

    /* table id is passed over here */
    let element = document.getElementById('export-section');
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, this.fileName);
    this.exportLoader = false;

  }

  // pdf download
  generatePdf() {
  
    const heads = [
      this.translate.instant('HOME.transaction'),
      this.translate.instant('HOME.debit'),
      this.translate.instant('HOME.credit')
    ];

      const lblXPos = 10;
      const headerHeight = 15;
      const valueXPos = 55;
      const data = [];

      data.push(
        [
          this.translate.instant('Common.Opening_Balance'),
          (this.saleData.op_bal).toFixed(this.country_dec),
          ''
        ],
        [
          this.translate.instant('HOME.van_trnfrd_goods'),
          (this.saleData.van_tran_goods).toFixed(this.country_dec),
          ''
        ],
        [
          this.translate.instant('HOME.van_trnfrd_ret__goods'),
          '',
          (this.saleData.van_tran_ret_goods).toFixed(this.country_dec)
        ],
        [
          this.translate.instant('HOME.cash_reved')+' ('+this.translate.instant('Common.exclude_tax')+')',
          '',
          (this.saleData.cash_recv).toFixed(this.country_dec)
        ],
        [
          this.translate.instant('HOME.bank_reved')+' ('+this.translate.instant('Common.exclude_tax')+')',
          '',
          (this.saleData.bank_recv).toFixed(this.country_dec)
        ],
        [
          this.translate.instant('HOME.adjust_tax'),
          '',
          (this.saleData.adjust_out).toFixed(this.country_dec)
        ],
        [
          '',
          (this.saleData.debit_total).toFixed(this.country_dec),
          (this.saleData.credit_total).toFixed(this.country_dec)
        ],
        [
          this.translate.instant('Common.Balance'),
          (this.saleData.balance).toFixed(this.country_dec),
          ''
        ]
        )
  
      let doc = this.excelService.getPdfObj();

      var addressLines = this.branch_address.split('\r\n');
      var addressText = addressLines.join(', ');

      doc.setFont('Amiri');
      doc.setFontSize(12);
      doc.text(this.branch_display_name +' ' + '(' + this.branch_display_code + ')', 70, headerHeight - 2);

      doc.setFont('Amiri');
      doc.setFontSize(9);
      doc.text(addressText, 71, headerHeight + 2);

      doc.setFontSize(10);
      doc.text(`${this.translate.instant('HOME.REPORT')}`, lblXPos, headerHeight + 10);
      doc.setFontSize(10);
      doc.text(':  ' + `${this.translate.instant('Van.van_distributors_rep')+'2'}`,  valueXPos, headerHeight + 10);

      doc.setFontSize(10);
      doc.text('Van', lblXPos, headerHeight + 15);
      doc.setFontSize(10);
      doc.text(':  ' + this.saleData.van_name,  valueXPos, headerHeight + 15);
      
      doc = this.excelService.addTableToPdf(doc, headerHeight + 20, lblXPos, heads, data, null);
  
     
      doc.save(`Van Distributors Report.pdf`);


    
  }

}
